<template>
  <div>
    <div class="canvas-box" id="myRadarChartTeam"></div>
  </div>
</template>

<script>
export default {
  props: ["model", "result"],
  data() {
    return {
      colors: [],
    };
  },
  mounted() {
    if (this.model) {
      this.renderMap();
    }
  },
  watch: {
    model(val) {
      this.renderMap();
    },
  },
  methods: {
    renderMap() {
      // console.log("result", this.result);
      this.loadData();
      if (this.result.length > 0) {
        let myRadarChart = this.$echarts.init(
          document.getElementById("myRadarChartTeam"),
          null,
          { renderer: "svg" }
        );
        let max = 0;
        this.result.map((item) => {
          if (max < item) {
            max = item;
          }
        });

        max = Math.ceil(max / 10) * 10;
        // console.log("max", max);

        let indicators = [];
        for (let i = 0; i < this.result.length; i++) {
          indicators.push({ max: max });
        }
        let seriesData = [];
        this.colors.map((item, index) => {
          let c = Object.assign({}, this.colors[index]);
          c = Object.assign(c, { name: item.name });
          seriesData.push(c);
        });

        // console.log("11", seriesData);
        let startAngle = 30;
        let intv = 360 / this.result.length;
        startAngle = 90 - intv / 2;
        let option = {
          color: ["#69C5EF"],
          radar: {
            shape: "circle",
            indicator: indicators,
            // splitNumber: 7,
            radius: 117, //缩放
            center: ["50%", "50%"], //位置
          },

          animation: false,
          series: [
            {
              type: "pie",
              startAngle: startAngle,
              radius: ["73%", "98%"],
              labelLine: {
                show: false,
              },
              label: {
                position: "inner",
                fontWeight: "bolder",
                color: "#fff",
                fontSize: 12,
              },
              data: seriesData,
            },
            {
              type: "radar",

              data: [
                {
                  value: this.result.reverse(),
                  name: "测试者标准分",
                  lineStyle: {
                    color: "#69C5EF",
                    type: "dashed",
                  },
                  label: {
                    show: true,
                    color: "black",
                  },
                  areaStyle: {
                    color: "#69C5EF",
                    opacity: 0.4, // 图形透明度
                  },
                },
              ],
            },
          ],
        };
        myRadarChart.setOption(option);
      }
    },
    loadData() {
      this.colors = [
        {
          name: "实干者",
          value: 1000,
          itemStyle: {
            color: "#FC5C64",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "协调者",
          value: 1000,
          itemStyle: {
            color: "#778CA2",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "推进者",
          value: 1000,
          itemStyle: {
            color: "#A65EEA",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "创新者",
          value: 1000,
          itemStyle: {
            color: "#4B7AED",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "信息者",
          value: 1000,
          itemStyle: {
            color: "#44AAF2",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "监督者",
          value: 1000,
          itemStyle: {
            color: "#2ACBBA",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "凝聚者",
          value: 1000,
          itemStyle: {
            color: "#50DB95",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "完善者",
          value: 1000,
          itemStyle: {
            color: "#FACD58",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "专家型",
          value: 1000,

          itemStyle: {
            color: "#FD9544",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas-box {
  width: 370px;
  height: 370px;
  margin: 1px auto 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/team/teamLatitudeRadar.vue